import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { buildBreadcrumbLd } from "@/lib/structured-data";

export const Route = createFileRoute("/_sticky/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy - Gatlinburg Wine Trail" },
      { name: "description", content: "How the Gatlinburg Wine Trail collects, uses, and protects your personal information." },
      { property: "og:title", content: "Privacy Policy - Gatlinburg Wine Trail" },
      { property: "og:description", content: "How the Gatlinburg Wine Trail collects, uses, and protects your personal information." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://demo.gatlinburgwinetrail.com/privacy" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Privacy Policy - Gatlinburg Wine Trail" },
      { name: "twitter:description", content: "How the Gatlinburg Wine Trail collects, uses, and protects your personal information." },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbLd([{ name: "Privacy Policy", path: "/privacy" }]),
        ),
      },
    ],
    links: [{ rel: "canonical", href: "https://demo.gatlinburgwinetrail.com/privacy" }],
  }),
  component: PrivacyPolicy,
});
